module.exports = "/assets/3c36a4bb0a08305e77b019ae4165f52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MG.png
// module id = 1613
// module chunks = 0